import { render, staticRenderFns } from "./BannerBox.vue?vue&type=template&id=3dd7a48d"
import script from "./BannerBox.vue?vue&type=script&lang=ts"
export * from "./BannerBox.vue?vue&type=script&lang=ts"
import style0 from "./BannerBox.vue?vue&type=style&index=0&id=3dd7a48d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports